//utilities
import errorMessage from '../../../Utilidades/errorMesagge'
//actions
import { listarLocation1, listarLocation2, listarLocation3, listarLocation4 } from '../../../Actions/Generales/UbicacionAction';

export const obtenerUbicacionNivel1 = async (idElementoPadre, setTableData, sesionUsuario, dispatch) => {
    await listarLocation1(idElementoPadre, sesionUsuario.usuario.companyId, sesionUsuario.usuario.userId).then(res => {
        if (res.status !== 200) {
            errorMessage(res, dispatch)
            setTableData([]);
            return
        }
        setTableData(res.data);
    });
};

export const obtenerUbicacionNivel2 = async (idElemento, idElementoPadre, sesionUsuario, dispatch) => {
    return await listarLocation2(idElemento, idElementoPadre, sesionUsuario.usuario.userId).then(res => {
        if (res.status !== 200) {
            errorMessage(res, dispatch)
            return []
        }
        return res.data;
    });
};

export const obtenerUbicacionNivel3 = async (idElemento, idElementoPadre, sesionUsuario, dispatch) => {
    return await listarLocation3(idElemento, idElementoPadre, sesionUsuario.usuario.userId).then(res => {
        if (res.status !== 200) {
            errorMessage(res, dispatch)
            return [];
        }
        return res.data;
    });
};

export const obtenerUbicacionNivel4 = async (idElemento, idElementoPadre, sesionUsuario, dispatch) => {
    return await listarLocation4(idElemento, idElementoPadre, sesionUsuario.usuario.userId).then(res => {
        if (res.status !== 200) {
            errorMessage(res, dispatch)
            return [];
        }
        return res.data;
    });
};